<template>
  <div class="default-layout page-container">
    <Header />
    <router-view />
    <RefrechLoginModal />
  </div>
</template>

<script>
import Header from "@/components/partials/HeaderItem.vue";
import RefrechLoginModal from "@/components/auth/RefrechLoginModal.vue";
import { mapGetters } from "vuex";
export default {
  name: "LayoutDefault",
  components: {
    Header,
    RefrechLoginModal,
  },
  methods: {
    checkUserActivity() {
      window.clearTimeout(this.activityTimeOut);
      this.activityTimeOut = window.setTimeout(() => {
        // this.$store.commit("mutate_login_timed_out", true);
      }, 600000);
    },
  },
  computed: {
    ...mapGetters(["loginTimedOut"]),
  },
  watch: {
    loginTimedOut(val) {
      const BODY = document.body;
      if (val) {
        if (BODY) {
          BODY.classList.add("login-refresh-modal");
        }
      } else {
        if (BODY) {
          BODY.classList.remove("login-refresh-modal");
        }
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.checkUserActivity, false);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.checkUserActivity, false);
    document.body.classList.remove("login-refresh-modal");
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 1000px;
}
</style>
